export default __webpack_public_path__ + "static/media/cp_geo_ad.828d9d8c.svg";